<p>rating-modal works!</p>
